// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3Izh3","overflowing":"ReadFullNote_overflowing__3zE-j"};